import HighlightsCritical from "@/component/CriticalCSS/HighlightsCritical";
const HighLights = ({
  highlights = [],
  isRajasthan = false,
  isMadhya = false,
  isHR = false,
  isUP = false,
  isBH = false,
  isCGH = false,
  isUK = false,
  isBiz = false,
  isPB=false
}) => {
  if (highlights.length > 5) {
    highlights.length = 5;
  }
  // console.log("the highlights are" , highlights)
  return (
    <>
      <HighlightsCritical />
      <div className={"outerContainer"}>
        <div
          className={`TitleDiv ${isRajasthan
            ? "text-rajasthanDark bg-rajasthanLight"
            : isMadhya
              ? "text-mpDark bg-mpLight"
              : isHR
                ? "text-hrDark bg-hrLight"
                : isBH
                  ? "text-biharDark bg-biharLight"
                  : isUP
                    ? "text-upDark bg-upLight"
                    : isCGH
                      ? "text-mpDark bg-mpLight"
                      : isUK
                        ? "text-ukDark bg-ukLight"
                        : isBiz ? "text-bizDark bg-bizLight"
                        : isPB ? "text-pbDark bg-pbLight"
                          : "text-primary bg-red-500 bg-opacity-20"
            }`}
        >
          ▌ <h2 className={"Heading"}>न्यूज़ हाइलाइट्स</h2>
        </div>
        <div className={"SubHead"}>
          {highlights.map((item, index) => (
            <div key={index} className={"rightArrow"}>
              {isUK || isBiz ? (
                
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#3A98D4"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
               
              ) : (
                <img
                  style={{ maxWidth: "12px" }}
                  src={
                    isRajasthan
                      ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/rj-tak-icon.png"
                      : isMadhya
                        ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/mptak-icon.png"
                        : isCGH
                          ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/mptak-icon.png"
                          :isPB 
                          ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/rj-tak-icon.png"
                          : "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/news-tak-icon.png"
                  }
                  alt="point"
                />
              )}

              <p className={"Content"}>{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HighLights;
